import ExternalFileChip from '@/components/FileAttachments/ExternalFile/ExternalFileChip';
import ExternalFileFilenameAndLink from '@/components/FileAttachments/ExternalFile/ExternalFileFilenameAndLink';
import { Link as LinkIcon } from '@mui/icons-material';
import { getHostname } from 'tldts';
import styled from '@emotion/styled';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import DeleteProofLink from './DeleteProofLink';
import { type RubricProofLink } from '@/lib/types';

const StyledLinkIcon = styled(LinkIcon)({
  width: 20,
  height: 20,
});

type ProofLinkProps = {
  proofLink: RubricProofLink;
};

const ProofLink = ({ proofLink }: ProofLinkProps) => (
  <ExternalFileChip>
    <StyledLinkIcon />
    <ExternalFileFilenameAndLink
      href={proofLink.link}
      target="_blank"
      rel="noopener noreferrer"
    >
      {getHostname(proofLink.link)}
    </ExternalFileFilenameAndLink>
    <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
      <DeleteProofLink proofLink={proofLink} />
    </RestrictedToPortfolioMode>
  </ExternalFileChip>
);

export default ProofLink;
